import React from "react";
import { Helmet } from "react-helmet-async";

export default function LesNocesDeGingko() {
  const titlePage = 'Les Noces de Gingko | Weblax';
  const description = 'Boutique en ligne pour fleuriste multi-ville.';

  return (
    <>
      <Helmet>
        <title>{titlePage}</title>
        <meta name="description" content={description} />
      </Helmet>

      <main className="weblax-container py-20">
        <h1 className="weblax-heading-display mb-6">Les Noces de Gingko</h1>
        <p className="text-lg text-muted-foreground mb-10">Boutique en ligne pour fleuriste multi-ville.</p>


        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Contexte</h2>
          <p className="text-muted-foreground">SEO local multi-ville.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Solution</h2>
          <p className="text-muted-foreground">E-commerce optimisé.</p>
        </section>
        
        <section className="mb-10">
          <h2 className="text-2xl font-bold mb-3">Résultats</h2>
          <p className="text-muted-foreground">Trafic renforcé.</p>
        </section>
        
      </main>
    </>
  );
}
